<template>
    <button
        :disabled="disabled"
        class="position-relative rounded-circle border-0 outline-none playButton"
        :class="buttonClass"
        :style="sizeButton"
        type="button"
    >
        <div
            class="position-absolute transition-bg-color transition-duration-100 transition-ease-out rounded-circle abs-center bg--black--50 w-100 h-100"
        />

        <v-icon
            class="text-light position-absolute abs-center"
            :name="isPlaying ? 'pause' : 'play'"
            :w="size / 2"
        />
    </button>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },

        isPlaying: {
            type: Boolean,
            default: false,
        },

        size: {
            type: Number,
            default: 46,
        },
    },

    computed: {
        buttonClass() {
            return {
                "cursor--pointer": !this.disabled,
                "cursor--not-allowed": this.disabled,
                "opacity--80": this.disabled,
            }
        },

        sizeButton() {
            return {
                width: `${this.size}px`,
                height: `${this.size}px`,
            }
        },
    },
}
</script>

<style scoped>
.playButton:hover div {
    background-color: rgba(0, 0, 0, 0.25) !important;
}
</style>
